module.exports = __webpack_public_path__ + "assets/xIcon.3c1fc6ce.svg";